import assets from './assets';

export default {
  start: {
    video: assets.startVideo,
    image: assets.start,
  },
  end: {
    ctaUrl: '#scheduler',
  },
  scenarios: [
    {
      key: 'scenarioA',
      title: 'Noise reduction and root cause analysis',
      steps: [
        {
          key: 'stepA1',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepA1,
        },
        {
          key: 'stepA2',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepA2,
        },
        {
          key: 'stepA3',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepA3,
        },
        {
          key: 'stepA4',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepA4,
        },
      ],
    },
    {
      key: 'scenarioB',
      title: 'Early detection',
      steps: [
        {
          key: 'stepB1',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB1,
        },
        {
          key: 'stepB2',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB2,
        },
        {
          key: 'stepB3',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB3,
        },
        {
          key: 'stepB4',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB4,
        },
        {
          key: 'stepB5',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB5,
        },
        {
          key: 'stepB6',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB6,
        },
        {
          key: 'stepB7',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepB7,
        },
      ],
    },
    {
      key: 'scenarioC',
      title: 'Early detection',
      steps: [
        {
          key: 'stepC1',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC1,
        },
        {
          key: 'stepC2',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC2,
        },
        {
          key: 'stepC3',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC3,
        },
        {
          key: 'stepC4',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC4,
        },
        {
          key: 'stepC5',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC5,
        },
        {
          key: 'stepC6',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC6,
        },
        {
          key: 'stepC7',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC7,
        },
        {
          key: 'stepC8',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC8,
        },
        {
          key: 'stepC9',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC9,
        },
        {
          key: 'stepC10',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepC10,
        },
      ],
    },
    {
      key: 'scenarioD',
      title: 'Early detection',
      steps: [
        {
          key: 'stepD1',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepD1,
        },
        {
          key: 'stepD2',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.stepD2,
        },
      ],
    },
  ],
};
